import styled from 'styled-components';
import logo from '../../resources/images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import auth from '../../api/auth';

// Components
import { OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import Avatar from '../Avatar/Avatar';

const Navbar = ({
  isAuth,
  // user,
  // setUser,
  setAuth
}) => {
  const history = useNavigate();
  const iconStyle = { marginRight: 7 }
  const buttonStyle = { marginLeft: 45 }
  const username = localStorage.getItem('username')


  const onLogout = () => {
    auth.logout((res) => {
      // setUser(null)
      setAuth(res);
      let client = localStorage.getItem('client')
      localStorage.removeItem('username')
      localStorage.removeItem('client')
      history(`/${client}`)
    })
  }

  if(!isAuth) {
    return (
      <Container>
        <LeftNav>
          <Logo src={logo} alt="Xogene - Sponsor Trial Website Admin"/>
        </LeftNav>
        <RightNav>
        </RightNav>
      </Container>
    );
  }

  const pathname = window.location.pathname.split('/')
  let client = ''
  if (pathname.length > 1) {  client = pathname[1]}

  return (
    <Container>
      <LeftNav>
        <Link to={`/${client}`}>
          <Logo src={logo} alt="Xogene - Sponsor Trial Website Admin"/>
        </Link>
        <ActionContainer>
        </ActionContainer>
      </LeftNav>
      <RightNav>
        <OverflowMenu
          style={{ width: "auto", padding: "0px 10px" }}
          flipped={true}
          renderIcon={() => (
            <UserContainer>
              {username && <Avatar username={username}/>}
              {username && <UserName>{username}</UserName>}
            </UserContainer>
          )}>
          {/* <OverflowMenuItem
            onClick={() => history.push("/settings/global-settings")}
            itemText="Global Settings" />
          <OverflowMenuItem
            onClick={() => history.push("/settings/prs-login-settings")}
            itemText="PRS Login Settings" />
          {user && user.permissions && user.permissions['user.create'] === true && user.permissions['user.edit'] === true && <OverflowMenuItem
            onClick={() => history.push("/settings/xogene-settings")}
            itemText="Xogene Settings" />} */}
          <OverflowMenuItem
            onClick={onLogout}
            isDelete
            itemText="Logout" />
        </OverflowMenu>
      </RightNav>
    </Container>
  );
};

export default Navbar;

const Container = styled.div`
  background-color: #fff;
  position: fixed;
  height: 4em;
  width: 100%;
  padding: 0 2em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  z-index: 10;
`

const LeftNav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Logo = styled.img`
  height: 1.8em;
  width: auto;
`

const Title = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 1em;
  line-height: 1em;
  letter-spacing: 2.32px;
  color: #6F6F6F;
  margin-left: 16px;
`

const RightNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`

const UserName = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 1em;
  color: #161616;
  margin-left: 10px;
`
